import React from "react";
import { Container, Row, Col, Nav } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link, Routes, Route, Navigate } from "react-router-dom";
import Layout from "../../../common_comp/Layout/Layout";
import Resources from "./Resources";
import Manuscript from "./Manuscript";
import Funding from "./Funding";
import General from "./General";
import Editorial from "./Editorial";
import Longterm from "./Longterm";
import Information from "./Information";
// import BspGuidelines from "./BspGuidelines";


const AuthorDash = () => {
  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", 
    });
  };


  return (
    <>
      <Layout>
        <Container fluid>
          <Row>
            <Col
              lg={3} sm={12}
           className="dashboard_layout"
            >
              <Nav className="flex-column">
                <Nav.Link
                  as={Link}
                  to="/information/for-authors-2/0-information-for-authors"
                  className="joab_common_navlink"
                  onClick={handleScrollToTop}
                >
                
               Information For Authors
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to="/information/for-authors-2/1-useful-resources-for-authors"
                  className="joab_common_navlink"
                  onClick={handleScrollToTop}
                >
                  
                  Useful Resources for Authors
                </Nav.Link>

                <Nav.Link
                  as={Link}
                  to="/information/for-authors-2/2-manuscript-submission-amp-instructions-for-authors"
                  className="joab_common_navlink"
                  onClick={handleScrollToTop}
                >
                 
               Manuscript Submission & Instructions for Authors
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to="/information/for-authors-2/5-funding-of-apcs-and-bpcs"
                  className="joab_common_navlink"
                  onClick={handleScrollToTop}
                >
                 
                 Funding of APCs
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to="/information/for-authors-2/10-general-peer-review-and-editorial-procedures"
                  className="joab_common_navlink"
                  onClick={handleScrollToTop}
                >
               
                General Peer-Review and Editorial Procedures
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to="/information/for-authors-2/11-editorial-decision-and-revision"
                  className="joab_common_navlink"
                  onClick={handleScrollToTop}
                >
                
               Editorial Decision and Revision
                </Nav.Link>

                <Nav.Link
                  as={Link}
                  to="/information/for-authors-2/12-long-term-archiving"
                  className="joab_common_navlink"
                  onClick={handleScrollToTop}
                > Long Term Archiving
                </Nav.Link>

                {/* <Nav.Link
                  as={Link}
                  to="/information/for-authors-2/13-bsp-guidelines-on-artificial-intelligence-and-authorship-"
                  className="joab_common_navlink"
                  onClick={handleScrollToTop}
                >     BSP Guidelines on Artifical Intelligence and Authorship
                </Nav.Link> */}
            
              </Nav>
            </Col>

            {/* Main Content Area */}
            <Col
              lg={8} sm={12}
              className="dashboard_content"
              // style={{
              //   padding: "2rem",
              //   // height: "100vh",
              //   // overflowY: "auto",
              // }}
            >
              <Routes>

              <Route
                  path="/"
                  element={<Information/>}
                />
                <Route
                  path="/0-information-for-authors"
                  element={<Information/>}
                />
                <Route
                  path="/1-useful-resources-for-authors"
                  element={<Resources />}
                />
                <Route
                  path="/2-manuscript-submission-amp-instructions-for-authors"
                  element={<Manuscript />}
                />
                <Route
                  path="/5-funding-of-apcs-and-bpcs"
                  element={<Funding />}
                />
                <Route
                  path="/10-general-peer-review-and-editorial-procedures"
                  element={<General />}
                />
                <Route
                  path="/11-editorial-decision-and-revision"
                  element={<Editorial />}
                />
                 <Route
                  path="/12-long-term-archiving"
                  element={<Longterm />}
                />
                 {/* <Route
                  path="/13-bsp-guidelines-on-artificial-intelligence-and-authorship-"
                  element={<BspGuidelines />}
                /> */}
                
                {/* Catch-all route for unmatched paths */}
                <Route
                  path="*"
                  element={<Navigate to="/not-found" replace />}
                />
              </Routes>
            </Col>
          </Row>
        </Container>
      </Layout>
    </>
  );
};

export default AuthorDash;
